import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ImproveLongFormFromContent(
    $projectId: ID!
    $creationJobId: ID
    $sections: [ImproveSectionInput!]
    $recomposeMode: RecomposeModeEnum!
    $instruction: Instruction
    $tovInput: TovInput
    $mediaGenerationParameters: MediaGenerationParametersInput
    $language: String
    $onlyImproveScore: Boolean
    $structureInstructionsData: JSON
  ) {
    improveLongFormFromContent(
      projectId: $projectId
      creationJobId: $creationJobId
      sections: $sections
      recomposeMode: $recomposeMode
      instruction: $instruction
      tovInput: $tovInput
      mediaGenerationParameters: $mediaGenerationParameters
      language: $language
      onlyImproveScore: $onlyImproveScore
      structureInstructionsData: $structureInstructionsData
    ) {
      id
    }
  }
`;

export const improveLongFormFromContent = async ({
  projectId,
  creationJobId,
  sections,
  recomposeMode,
  instruction,
  tovInput,
  mediaGenerationParameters,
  language,
  onlyImproveScore,
  structureInstructionsData,
}) => {
  const variables = {
    projectId,
    creationJobId,
    sections,
    recomposeMode,
    instruction,
    tovInput,
    mediaGenerationParameters,
    language,
    onlyImproveScore,
    structureInstructionsData,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
